export default "__VITE_ASSET__CVJfouDr__"